import React from 'react';
import Section from './Compartido/section.jsx';
import Footer from './Compartido/footer.jsx';
import MenuWrapper from './Compartido/menu.jsx';
import PaginaNoEncontrada from '../../Components/PaginaNoEncontrada.jsx';
import { useTranslation } from 'react-i18next';

import "./../../../../css/apartur/rs6.css";
import "./../../../../css/apartur/structure.css";
import "./../../../../css/apartur/global.css";
import "./../../../../css/apartur/sweetaltert2.min.css";
import "./../../../../css/apartur/custom.css";
import './../../../../css/apartur/partners.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./../../../../css/apartur/styles.css"
import "./../../../../css/apartur/apartur.css";


const NoEncontrada = (props) => {
    const { t } = useTranslation();

    return (
        <body className="page template-slider button-round layout-full-width if-border-hide no-content-padding header-classic header-fw minimalist-header-no sticky-header sticky-tb-color ab-hide subheader-both-left menu-link-color menuo-right menuo-no-borders mobile-tb-hide mobile-side-slide mobile-mini-mr-ll tablet-sticky mobile-sticky scroll" >
            <div id="Wrapper">
                <div id="Header_wrapper">
                    <header id="Header">
                        <MenuWrapper
                            preidioma={props.lang != 'es' ? props.lang + "/" : ""}
                            lang={props.lang}
                            config={props.websgrupo}
                            ruta={props.ruta}
                            meta_titulo={t("Página no encontrada") + " - " + props.meta_titulo}
                            meta_descripcion={props.meta_descripcion}
                            meta_keywords={props.meta_keywords}
                        />
                    </header>
                </div>
                <PaginaNoEncontrada
                    urlinicio={props.urlinicio}
                    websgrupo={props.websgrupo}
                />
            </div>

            <div className="section pTop75pB30" >
                <Section />
            </div>

            <footer id="Footer" className="clearfix">
                <Footer
                    lang={props.lang}
                    websgrupo={props.websgrupo}
                />
            </footer>

            <div id="Side_slide" className="right dark" data-width="250">
                <div className="close-wrapper">
                    <a href="#" className="close"><i className="icon-cancel-fine"></i></a>
                </div>

                <div className="menu_wrapper"></div>
            </div>

            <div id="body_overlay"></div>
        </body>
    );
}

export default NoEncontrada;
